<template>
	<div>
		<b-modal
			ref="loaderModal"
			hide-footer
			title="Chargement..."
		>
			<throbber />
			<p class="my-4">{{ $t("Tooltip.message_wait") }}</p>
		</b-modal>
		<b-modal
			ref="modalError"
			hide-footer
			title="Erreur"
		>
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<div class="valid_button">
			<button
				type="submit"
				class="btn btn-valid"
				@click.prevent="sendDatas"
				:disabled = disabled
			>{{ $t("Button.validate") }}
			</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import {EventBus} from "../../../event/event-bus.js";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "ValidStepOffice",
	components: {
		throbber,
		lottie_error,
	},
	props: {
		videoArray: {
			type: Array,
			"default": () => [],
		},
		valueSubtitle: String,
		stepOrder: Number,
		valueTitle: String,
		valueKeywords: String,
		muted: Boolean,
		music_enabled: Boolean,
		volume: Number,
		music_volume: Number,
		id: Number,
		completed: Boolean,
		stepId: Number,
		step_type: String,
		subtype: String,
		uploadVideoFile: Array,
		hasUploadedFile: Boolean,
		modal: "",
		activate_upload: Boolean,
		disabled: Boolean,
	},
	data() {
		return {
			text_error: "",
			files: [],
		};
	},
	methods: {
		sendDatas() {
			let $this = this;
			this.$refs.loaderModal.show();

			let bodyFormData = new FormData();
			if (this.videoArray !== undefined) {
				if (this.videoArray.length > 0) {
					this.ambianceId = this.videoArray[0].id;
					bodyFormData.append("ambianceId", this.ambianceId);
					bodyFormData.append("isCompleted", "1");
				}
			}
			bodyFormData.append("_method", "put");
			if (this.valueTitle !== undefined) {
				bodyFormData.append("title", this.valueTitle);
			}
			if (this.valueSubtitle !== undefined) {
				bodyFormData.append("secondaryTitle", this.valueSubtitle);
			}
			if (this.valueKeywords !== undefined) {
				bodyFormData.append("keywords", this.valueKeywords);
			}
			if (this.muted !== undefined) {
				bodyFormData.append("muted", this.muted ? "true" : "false");
			}
			if (this.music_enabled !== undefined) {
				bodyFormData.append("music_enabled", this.music_enabled ? "true" : "false");
			}
			if (this.volume !== undefined) {
				bodyFormData.append("volume", this.volume.toString());
			}
			if (this.music_volume !== undefined) {
				bodyFormData.append("music_volume", this.music_volume.toString());
			}
			if (this.uploadVideoFile !== undefined && this.activate_upload) {
				if (this.uploadVideoFile.length > 0) {
					bodyFormData.append("video", this.uploadVideoFile[0].file);
					bodyFormData.append("stepIndex", this.stepOrder);
				}
			}
			axios.post(BASE_URL + "/public/api/stepAmbiances/" + this.id,
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.$refs.loaderModal.hide();
				EventBus.$emit("isSaved", true);
				if ($this.uploadVideoFile.length > 0 || $this.completed) {
					EventBus.$emit("setStepAmbianceComplete", $this.id);
					EventBus.$emit("hasVideo", true);
				}
				if ($this.videoArray !== undefined) {
					if ($this.videoArray.length > 0) {
						EventBus.$emit("videoCarouselChoose", true);
						EventBus.$emit("setStepAmbianceComplete", $this.id);
					}
				}
				EventBus.$emit("stepAmbianceReload", $this.id);
				EventBus.$emit("setModificationTitleLabel", "");
				EventBus.$emit("setModificationSecondaryTitleLabel", "");
				EventBus.$emit("setModificationKeywordsLabel", "");
				EventBus.$emit("setModified", false);
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});
		},
	},
};
</script>

<style scoped>
.btn-valid {
	background-color: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
	border-radius: var(--small-border-radius);
}
</style>
